<div
  class="body-wrapper rtl"
  style="padding-top: 0; width: 500px; padding-right: 7em; padding-left: 2.5em"
>
  <div class="t-popup popup-patientDetails">
    <div class="t-popup-close"></div>

    <div class="t-popup-frame" style="width: 65em; max-width: fit-content">
      <div class="t-popup-body" [formGroup]="concentForm">
        <h2 style="direction: rtl">הסכמה מדעת</h2>

        <div
          id="concent"
          #concent
          class="m-box w100"
          style="direction: rtl; font-size: 12px; margin-left: 2em; margin-right: 2em"
        >
          <span>
            <h2>{{ getConsentTitle() }}</h2>
          </span>
          <div style="direction: rtl; margin-bottom: 1em">
            <span *ngIf="concentForm.get('GynConsentType').value === 'Hysterosalpingo Sonography'">
              היסטרוסלפינגוסונוגרפיה היא בדיקה לאבחון חסימה בחצוצרות הרחם באמצעות אולטרסאונד. הבדיקה
              מתבצעת על ידי הכנסת צנתר דרך הנרתיק אל צוואר הרחם והזרקת תמיסת מלח לחלל הרחם. באמצעות
              אולטרסאונד ניתן לראות את מילוי חלל הרחם ואת זרימת המים החוצה מהרחם, דרך החצוצרות, לחלל
              הבטן. בדיקה זו מתבצעת בדרך כלל בשבוע הראשון לאחר הווסת, לפני הביוץ.
            </span>
            <span *ngIf="concentForm.get('GynConsentType').value === 'Insertion of IUD'">
              התקן תוך רחמי (IUD) הוא אמצעי למניעת הריון. קיימים שני סוגי התקנים עיקריים: התקן נחושת
              והתקן הורמונלי. ההתקן מוכנס לרחם על ידי רופא ויכול להישאר במקום למשך מספר שנים, בהתאם
              לסוג ההתקן.
            </span>
          </div>
          <div>
            <span><strong>שם הנבדקת</strong></span>
          </div>
          <div style="display: flex; margin-bottom: 2em">
            <div
              class="login-form-row"
              style="background-color: #e4eded; margin: 5px; display: flex; flex-direction: column"
            >
              <label for="First">שם פרטי</label>
              <input formControlName="First" type="text" disabled />
            </div>
            <div
              class="login-form-row"
              style="background-color: #e4eded; margin: 5px; display: flex; flex-direction: column"
            >
              <label for="Last">שם משפחה</label>
              <input formControlName="Last" type="text" disabled />
            </div>
            <div
              class="login-form-row"
              style="background-color: #e4eded; margin: 5px; display: flex; flex-direction: column"
            >
              <label for="ID">ת.ז.</label>
              <input formControlName="ID" type="text" disabled />
            </div>
            <div
              class="login-form-row"
              style="background-color: #e4eded; margin: 5px; display: flex; flex-direction: column"
            >
              <label for="Phone">טלפון</label>
              <input formControlName="Phone" type="text" disabled />
            </div>
          </div>

          <div
            *ngIf="concentForm.get('GynConsentType').value === 'Insertion of IUD'"
            style="margin: 1em 0"
          >
            <span style="display: flex; align-items: center">
              <strong style="margin-left: 1em">סוג ההתקן:</strong>
              <span>{{ concentForm.get('iudType').value }}</span>
            </span>
          </div>
          <div>
            <span>
              ניתן לי הסבר מפורט על אופן הבדיקה, מהלכה, סיכוניה, הסיבוכים והתוצאות האפשריות שלה.
              הובהר לי כי לא ניתן להבטיח תוצאה מסוימת. קיבלתי הזדמנות לשאול שאלות ולקבל תשובות
              מספקות.
            </span>
          </div>
          <div style="display: grid; gap: 1em; margin: 2em 0">
            <span>
              <strong style="margin: 0 1em">הבדיקה התבצעה על ידי:</strong>
              <input
                formControlName="refferalDoc"
                type="text"
                disabled
                style="width: fit-content; padding: 0.5em; margin-top: 0.5em"
              />
            </span>
            <div class="login-form-row">
              <label style="margin: 0 1em" for="CreationTime">תאריך ביצוע:</label>
              <input formControlName="CreationTime" type="datetime-local" disabled />
            </div>
          </div>
          <div style="display: grid; place-self: center">
            <span>חתימת המטופלת\אפוטרופוס</span>
            <img
              *ngIf="concentForm.get('patSign').value"
              [src]="concentForm.get('patSign').value"
              style="width:500px; height:200px; border:1px solid black; display:block;"
            />
            <div
              *ngIf="!concentForm.get('patSign').value"
              style="width:500px; height:200px; border:1px solid black;"
            ></div>
          </div>
          <hr class="r-concent" />

          <!-- Insertion of IUD Content -->
          <ng-container *ngIf="concentForm.get('GynConsentType').value === 'Insertion of IUD'">
            <div class="r-concent">
              <strong>תופעות לוואי אפשריות:</strong>
            </div>

            <div class="r-concent">
              • שינויים בדפוס הדימום החודשי (התקן נחושת עלול להגביר דימום, התקן הורמונלי עלול להקל
              על הדימום או אף להפסיקו).
            </div>

            <div class="r-concent">• כאבי בטן וגב בזמן ההחדרה ולאחריה.</div>

            <div class="r-concent">• סיכון נמוך לזיהום באגן.</div>

            <div class="r-concent">• סיכון נדיר לנקב ברחם בעת ההחדרה.</div>

            <div class="r-concent">• סיכון נמוך להריון חוץ רחמי במקרה של כשל באמצעי המניעה.</div>

            <div class="r-concent">
              • בהתקן הורמונלי - תופעות לוואי הורמונליות כגון: שינויים במצב הרוח, כאבי ראש, רגישות
              בשדיים.
            </div>

            <div class="r-concent">• פליטת ההתקן מבלי לחוש/לדעת שההתקן נפלט.</div>

            <div class="r-concent">
              <strong>מתי יש לפנות לרופא:</strong>
            </div>

            <div class="r-concent">• חום מעל 38 מעלות.</div>

            <div class="r-concent">• הפרשה לדנית עם ריח רע.</div>

            <div class="r-concent">• כאבים עזים בבטן התחתונה.</div>

            <div class="r-concent">• דימום חריג בעוצמתו או בעיתויו.</div>

            <div class="r-concent">• כאבי בטן תחתונה, במיוחד אם מלווים בחום.</div>

            <div class="r-concent">• הפרשה לדנית חריגה.</div>

            <div class="r-concent">• איחור של הוסת.</div>

            <div class="r-concent">• תחושה שההתקן נפלטה או אי הרגשת חוטי ההתקן.</div>

            <div class="r-concent">
              <strong>הוראות לאחר ההחדרה:</strong>
            </div>
            <div class="r-concent">• מומלץ מנוחה למשך 24 שעות.</div>
            <div class="r-concent">• להימנע מקיום יחסי מין למשך 48 שעות.</div>
            <div class="r-concent">• להימנע משימוש בטמפונים למשך שבוע.</div>
            <div class="r-concent">• מומלץ בדיקת מעקב לאחר חודש להבטחת מיקום תקין של ההתקן.</div>
          </ng-container>

          <!-- Hysterosalpingo Sonography Content -->
          <ng-container
            *ngIf="concentForm.get('GynConsentType').value === 'Hysterosalpingo Sonography'"
          >
            <div class="r-concent">
              <strong>1. מהות הבדיקה:</strong> בדיקת היסטרוסלפינגוסונוגרפיה נועדה לבחון את חלל הרחם
              ואת פתיחות החצוצרות. הבדיקה מתבצעת על ידי הזרקת תמיסת מלח סטרילית לתוך חלל הרחם תוך
              צפייה באולטרסאונד.
            </div>
            <div class="r-concent">
              <strong>2. תכלית הבדיקה:</strong> אבחון חסימות בחצוצרות, גידולים או פוליפים בחלל הרחם,
              הידבקויות ומומים מבניים ברחם.
            </div>
            <div class="r-concent">
              <strong>3. מהלך הבדיקה:</strong> הבדיקה מתבצעת בדרך כלל בשבוע הראשון לאחר הווסת. תוך
              כדי בדיקת אולטרסאונד נרתיקית, מוחדר צנתר דק דרך צוואר הרחם ומוזרקת תמיסת מלח סטרילית.
            </div>
            <div class="r-concent">
              <strong>4. אי נוחות וכאב:</strong> ייתכן תחושת אי נוחות או כאב קל במהלך הבדיקה
              ולאחריה, הדומה לכאבי וסת. מומלץ ליטול משכך כאבים כשעה לפני הבדיקה.
            </div>
            <div class="r-concent">
              <strong>5. סיכונים וסיבוכים:</strong> הבדיקה בטוחה יחסית, אך קיים סיכון נדיר לזיהום,
              דימום, תגובה אלרגית לתמיסה או נקב ברחם (נדיר ביותר).
            </div>
            <div class="r-concent">
              <strong>6. סימנים לפנייה רפואית דחופה:</strong> חום מעל 38°, כאבי בטן עזים שאינם
              חולפים, דימום כבד, הפרשה לדנית בעלת ריח רע.
            </div>
            <div class="r-concent">
              <strong>7. מגבלות הבדיקה:</strong> הבדיקה אינה יכולה לאבחן כל בעיה אפשרית ברחם או
              בחצוצרות. בחלק מהמקרים ייד רשו בדיקות השלמה.
            </div>
          </ng-container>

          <div class="r-concent">
            <strong>אני מאשר/ת שקיבלתי הסבר מפורט על הבדיקה, סיכוניה והחלופות האפשריות.</strong>
          </div>
          <div class="r-concent">
            <strong>אני נותן/ת בזאת את הסכמתי לביצוע הבדיקה/פעולה.</strong>
          </div>
          <div style="display: grid; margin-bottom: 1em">
            <input
              formControlName="CreationTime"
              type="datetime-local"
              disabled
              style="width: 50%; place-self: center"
            />
          </div>

          <div
            [ngClass]="concentForm.get('approved').value === 'paitent' ? '' : 'hidden'"
            style="display: grid; place-self: center"
          >
            <span>חתימת הנבדקת\אפוטרופוס</span>
            <img
              *ngIf="concentForm.get('patSignApproved').value"
              [src]="concentForm.get('patSignApproved').value"
              style="width:400px; height:150px; border:1px solid black; display:block;"
            />
            <div
              *ngIf="!concentForm.get('patSignApproved').value"
              style="width:400px; height:150px; border:1px solid black;"
            ></div>
          </div>

          <div class="r-concent">
            <span>אני מאשר כי הסברתי בעל פה</span>
            <div
              class="l-flex-c l-flex-w indicative-fieldset h100"
              style="justify-content: space-evenly"
            >
              <label class="t-label-top">
                <input
                  type="radio"
                  formControlName="approved"
                  value="paitent"
                  class="custom-check -sq"
                />
                <i class="customInput-display -sq" style="margin-left: 0.31em"></i>
                <span> למטופלת </span>
              </label>
              <label class="t-label-top">
                <input
                  type="radio"
                  formControlName="approved"
                  value="appotropus"
                  class="custom-check -sq"
                />
                <i class="customInput-display -sq" style="margin-left: 0.31em"></i>
                <span> לאפוטרופוס </span>
              </label>
              <label class="t-label-top">
                <input
                  type="checkbox"
                  name="placenta_TEMP_name"
                  class="custom-check -sq"
                  formControlName="translated"
                  [value]="1"
                />
                <i class="customInput-display"></i>
                <span> למתרגם של המטופלת </span>
              </label>
              <div *ngIf="concentForm.get('translated').value == 1">
                <div
                  class="login-form-row"
                  style="
                    background-color: #e4eded;
                    margin: 5px;
                    border-radius: 0.75em;
                    height: fit-content;
                  "
                >
                  <input
                    formControlName="transName"
                    class="l-textarea t-field--limitRad"
                    style="margin-left: 5px; border-radius: inherit"
                  />
                </div>
                <div
                  class="login-form-row"
                  style="
                    background-color: #e4eded;
                    margin: 5px;
                    border-radius: 0.75em;
                    height: fit-content;
                  "
                >
                  <input
                    formControlName="transRel"
                    class="l-textarea t-field--limitRad"
                    style="margin-left: 5px; border-radius: inherit"
                  />
                </div>
              </div>
            </div>
            <div
              *ngIf="concentForm.get('ExamType').value !== 'NT'"
              style="padding: 2em; height: 10px"
            ></div>
            <div
              [ngStyle]="concentForm.get('ExamType').value !== 'NT' ? { 'margin-top': '70px' } : {}"
            >
              את כל האמור לעיל בפירוט הדרוש וכי הוא/היא חתם/ה על הסכמה בפני לאחר ששוכנעתי כי הבין/ה
              את הסבריי במלואם.
            </div>
            <div *ngIf="concentForm.get('approved').value === 'appotropus'">
              <div style="display: flex">
                <div
                  class="login-form-row"
                  style="
                    background-color: #e4eded;
                    margin: 5px;
                    border-radius: 0.75em;
                    height: fit-content;
                  "
                >
                  <input
                    formControlName="appName"
                    class="l-textarea t-field--limitRad"
                    style="margin-left: 5px; border-radius: inherit"
                  />
                </div>
                <div
                  class="login-form-row"
                  style="
                    background-color: #e4eded;
                    margin: 5px;
                    border-radius: 0.75em;
                    height: fit-content;
                  "
                >
                  <input
                    formControlName="appRel"
                    class="l-textarea t-field--limitRad"
                    style="margin-left: 5px; border-radius: inherit"
                  />
                </div>
              </div>
              <div style="display: grid; place-self: center">
                <span>חתימת אפוטרופוס</span>
                <img
                  *ngIf="concentForm.get('appSign').value"
                  [src]="concentForm.get('appSign').value"
                  style="width:500px; height:200px; border:1px solid black; display:block;"
                />
                <div
                  *ngIf="!concentForm.get('appSign').value"
                  style="width:500px; height:200px; border:1px solid black;"
                ></div>
              </div>
            </div>
            <div style="display: flex; margin-top: 2em">
              <div
                class="login-form-row"
                style="background-color: #e4eded; margin: 5px; border-radius: 0.75em; width: 30%;  display: flex; align-items: center; justify-content: center;"
              >
                 <input
                  formControlName="refferalDoc"
                  class=" center-val"
                  style="margin-left: 5px; border-radius: inherit; border: none;"
                />
              </div>
              <!-- ======= Doctor Credentials (Start) ======= -->
              <div class="doc-credentials login-form-row">
                @if (concentForm.get('DrNum')?.value) {
                  <span>מ.ר. <strong>{{ concentForm.get('DrNum')?.value }}</strong></span>
                }
                @if (concentForm.get('ExpertNum')?.value) {
                  <span>מ.ר.מ. <strong>{{ concentForm.get('ExpertNum')?.value }}</strong></span>
                }
                @if (concentForm.get('NurseNum')?.value) {
                  <span>מ.ר. <strong>{{ concentForm.get('NurseNum')?.value }}</strong></span>
                }
                @if (concentForm.get('TechNum')?.value) {
                  <span>מ.ר. <strong>{{ concentForm.get('TechNum')?.value }}</strong></span>
                }
              </div>
              <!-- ======= Doctor Credentials (End) ======= -->
              <div
                class="login-form-row center-val"
                style="background-color: #e4eded; margin: 5px; border-radius: 0.75em; width: 30%"
              >
                <span>
                  {{ concentForm.get('CreationTime').value | date: 'HH:mm dd/MM/yyyy' }}
                </span>
              </div>
            </div>
            <div style="display: grid; place-self: center">
              <span>חתימת הרופא</span>
              <img
                *ngIf="concentForm.get('docSign').value"
                [src]="concentForm.get('docSign').value"
                style="width:500px; height:200px; border:1px solid black; display:block;"
              />
              <div
                *ngIf="!concentForm.get('docSign').value"
                style="width:500px; height:200px; border:1px solid black;"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- the PDF renderer waits for .finished before capturing the page -->
  @if (loaded) {
    <span class="finished"></span>
  }
  </div>
</div>
